// .core
import React, { useCallback, useState } from 'react'
// components
import { Layout } from 'layouts/Layout'
import { HomeContent } from './Home.content'

export default function Home() {
  const [shouldAnimateFooter, setShouldAnimateFooter] = useState<boolean>(false)

  const setAnimateFooterFalse = useCallback(() => {
    setShouldAnimateFooter(false)
  }, [])

  const setAnimateFooterTrue = useCallback(() => {
    setShouldAnimateFooter(true)
  }, [])

  return (
    <Layout hideBackdrop footerAnimate={shouldAnimateFooter}>
      <HomeContent onLoadLast={setAnimateFooterTrue} onUnloadLast={setAnimateFooterFalse} />
    </Layout>
  )
}
